import React                          from 'react';
import classnames                     from 'classnames';
import PropTypes                      from 'prop-types'

import PriceMatrixHead                from '../PriceMatrixHead';
import MobilePriceMatrixBody          from './MobilePriceMatrixBody';

const MobilePriceMatrix = (props) => {
  const {
    leadTimes,
    lineItem,
    matrixClass,
  } = props;

  const {quantities} = lineItem;
  const cssClass = classnames('table table-bordered table-price-matrix', {
    'table-striped': props.tableStripe,
    'table-sm'     : props.tableSm,
  })

  return (
    <div className={classnames('table-responsive', matrixClass)}>
      <table className={cssClass}>
        <PriceMatrixHead leadTimes={leadTimes} />
        <MobilePriceMatrixBody
          quantities={quantities}
          leadTimes={leadTimes}
          {...props} />
      </table>
    </div>
  );
};

MobilePriceMatrix.defaultProps = {
  tableStripe: false,
  tableSm    : false,
  matrixClass: '',
}

MobilePriceMatrix.propTypes = {
  lineItem: PropTypes.object.isRequired,
  showSummary: PropTypes.bool.isRequired,
  rowSelected: PropTypes.number,
}

export default MobilePriceMatrix;